import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { useForm } from "react-hook-form";

import Header from "../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPerson, faWarehouse, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button, Col, Row } from "react-bootstrap";
import Datepicker from "../../common/Datepicker";
import { getAllData } from "../../../utils/apis/lnvestorsledger/lnvestorsledger";
import { formatDate } from "../../../utils/common";
import ExportMethod from "../../../utils/apis/ExportMethod";
import Pagination from "../../common/Pagination";
import FundManage from "./FundManage";
import UserWiseReport from "./UserWiseReport";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  

  return (
    <>
      <div className="main-advancedashboard">
        <div className="investor">
          <Header
            icon={faWarehouse}
            title={"Reports List"}
            link={"/payment/inward-payment"}
          />
         <FundManage />
         <UserWiseReport />
        </div>
      </div>
    </>
  );
};

export default Tables;
